import { ReactNode, useEffect, useState } from "react";
import "@/shared/styles/layouts/auth-layout/auth-layout.scss";
import Logo from "@/shared/components/logo/logo";

interface AuthLayoutProps {
  children: ReactNode;
  rightComponent: ReactNode;
}

export default function AuthLayout({
  children,
  rightComponent,
}: AuthLayoutProps) {
  const [pageHeight, setPageHeight] = useState(0);
  const partClass =
    "w-full lg:w-1/2 lg:px-0 flex flex-col items-center h-full rounded-lg relative";

  useEffect(() => {
    setPageHeight(window.innerHeight);
    const handleResize = () => {
      setPageHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="h-screen relative">
      <div
        className={`login-layout flex justify-center items-center h-[100vh]`}
        style={{ height: pageHeight < 600 ? "140vh" : "100vh" }}
      >
        <div className={partClass + " part-left"}>
          <Logo height={"38px"} />
          <div className="w-full h-full flex justify-center">
            <div className="mt-[240px]">{children}</div>
          </div>
        </div>
        <div className={`${partClass} hidden lg:flex`}>{rightComponent}</div>
      </div>
    </div>
  );
}
